/**
 * Constants and configuration for deployment cost calculator
 */

// Chart colors for each deployment option
export const CHART_COLORS = {
    'Purchased Hardware': '#8884d8',      // Blue
    'Cloud Rental': '#82ca9d',            // Green
    'Token Usage': '#ffc658',             // Yellow
    'Provisioned Throughput': '#a78bfa',  // Purple
    'Hybrid': '#ff7c7c'                   // Red
};

// Default slider values
export const DEFAULT_VALUES = {
    sessionsPerMonth: 100000,
    operationsHoursPerDay: 8,
    tokensPerRequest: 2000,
    tokensInResponse: 100,
    requestsPerSession: 2,
    percentResponseInSubsequent: 100,
    yoyGrowthPercent: 0,
    hybridOnPremPercent: 80
};

// Slider ranges
export const SLIDER_RANGES = {
    sessionsPerMonth: { min: 100000, max: 20000000, step: 100000 },
    operationsHoursPerDay: { min: 1, max: 24, step: 1 },
    tokensPerRequest: { min: 100, max: 100000, step: 100 },
    tokensInResponse: { min: 10, max: 5000, step: 10 },
    requestsPerSession: { min: 1, max: 20, step: 1 },
    percentResponseInSubsequent: { min: 0, max: 100, step: 10 },
    yoyGrowthPercent: { min: 0, max: 100, step: 5 },
    hybridOnPremPercent: { min: 0, max: 100, step: 5 }
};

// Number of years for projection
export const PROJECTION_YEARS = 5;

// Deployment option types
export const DEPLOYMENT_TYPES = {
    HARDWARE: 'Purchased Hardware',
    RENTAL: 'Cloud Rental',
    TOKENS: 'Token Usage',
    PROVISIONED: 'Provisioned Throughput',
    HYBRID: 'Hybrid Deployment'
};

// Hybrid cloud options
export const HYBRID_OPTIONS = {
    RENTAL: 'rental',
    TOKENS: 'tokens',
    PROVISIONED: 'pt'
};
